module.exports = __webpack_public_path__ + "img/img_correcto.992adfdc.svg";